var bighouse = bighouse || {};

bighouse.clipboard = (function () {

    var failed = false;

    function init() {


        $('.js-copyLink').on('click', function(e){


            if(failed) return;

            var currentUrl = document.location;

            var success = copyToClipboard(currentUrl);

            if(success){  
                $(this).find('.js-copyLinkStart').addClass('u-hide');
                $(this).find('.js-copyLinkSuccess').removeClass('u-hide');
            } else {
                failed = true;
                $(this).find('.js-copyLinkStart').html('Unable to auto copy link');
                $(this).after('<div class="Lightbox-shareInput"><input type="text" value="'+ currentUrl +'"></div>');
            }

            e.preventDefault();
        });

        $('.js-copyLinkReset').on('click', function(){
            $('.js-copyLinkStart').removeClass('u-hide');
            $('.js-copyLinkSuccess').addClass('u-hide');
        });
    }


    //credit to: https://hackernoon.com/copying-text-to-clipboard-with-javascript-df4d4988697f
    const copyToClipboard = (str) => {
        const el = document.createElement('textarea');  // Create a <textarea> element
        el.value = str;                                 // Set its value to the string that you want copied
        el.setAttribute('readonly', '');                // Make it readonly to be tamper-proof
        el.style.position = 'absolute';                 
        el.style.left = '-9999px';                      // Move outside the screen to make it invisible
        document.body.appendChild(el);                  // Append the <textarea> element to the HTML document
        const selected =            
        document.getSelection().rangeCount > 0        // Check if there is any content selected previously
            ? document.getSelection().getRangeAt(0)     // Store selection if found
            : false;                                    // Mark as false to know no selection existed before
        el.select();                                    // Select the <textarea> content
        var success = document.execCommand('copy');                   // Copy - only works as a result of a user action (e.g. click events)
        document.body.removeChild(el);                  // Remove the <textarea> element
        if (selected) {                                 // If a selection existed before copying
            document.getSelection().removeAllRanges();    // Unselect everything on the HTML document
            document.getSelection().addRange(selected);   // Restore the original selection
        }

        return success;
    };


    
    return {
        init: init
    };
})();

